/** Type of organization for a company or counterparty (based on the laws of the Russian Federation) */
export enum PersonTypeEnum {
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  INDIVIDUAL_ENTREPRENEUR = 'INDIVIDUAL_ENTREPRENEUR',
  PRIVATE_CUSTOMER = 'PRIVATE_CUSTOMER',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  SEPARATE_DIVISION = 'SEPARATE_DIVISION',
  GOVERNMENT_AGENCY = 'GOVERNMENT_AGENCY',
}
